import { Clerk } from "@clerk/clerk-js";
import { getVanillaClient } from "@youka/trpc-client";
import config from "@/config";

const clerk = new Clerk(config.clerk);

export async function getOnlineClient() {
  if (!clerk.loaded) {
    await clerk.load();
  }
  const token = await clerk.session?.getToken();
  if (!token) {
    throw new Error("No token");
  }
  return getVanillaClient(config.onlineApi, token);
}
